import { render, staticRenderFns } from "./RowService.vue?vue&type=template&id=35a07b00&scoped=true"
import script from "./RowService.vue?vue&type=script&lang=js"
export * from "./RowService.vue?vue&type=script&lang=js"
import style0 from "./RowService.vue?vue&type=style&index=0&id=35a07b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a07b00",
  null
  
)

export default component.exports